<template>
  <div />
</template>

<script>
export default {
  mounted() {
    window.location.href = this.$t('footerAd.redirectUrl') + this.$route.query.a;
  },
};
</script>

<style></style>
